<template>
  <CModal :show.sync="show" :title="$pgettext('photo_search.set_pica_code', 'Set Pica Code')" centered>
  <CInput v-model="pica_code" placeholder="Pica Code"/>
    <template #footer>
      <CButton @click="show = false" color="secondary" v-translate>Close</CButton>
      <PButton @click="onSetPicaCode" color="primary" translate-context="photo_search.set_pica_code" v-translate>
        Set Pica Code
      </PButton>
    </template>
  </CModal>
</template>

<script>
import {mapActions} from "vuex";
import PButton from "@/components/PButton.vue";

export default {
  name: "SetPicaCodeModal",
  components: {PButton},
  data() {
    return {
      show: false,
      pica_code: null,
    }
  },
  emits: ['set'],
  methods: {
    ...mapActions('photoSearch', [
      'validatePicaCode',
    ]),
    async open() {
      this.show = true
      this.pica_code = null
    },
    async onSetPicaCode() {
      if (!this.pica_code) {
        await this.notifyError(this.$pgettext('photo_search.set_pica_code', 'Please enter a Pica Code'))
        return
      }
      const isValid = await this.validatePicaCode(this.pica_code)
      if (!isValid) {
        await this.notifyError(this.$pgettext('photo_search.set_pica_code', 'Invalid Pica Code'))
        return
      }

      await this.emitPromised('set', {pica_code: this.pica_code})
      this.show = false
    }
  }
}
</script>